document.documentElement.classList.remove('no-js');
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  nav.hidden = open;
});
document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const option = selector.options[selector.selectedIndex];
  const form = selector.closest('form');
  const id = form && form.querySelector('[name="id"]');
  if (id) id.value = option.value;
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const viewport = carousel.querySelector('[data-carousel-viewport]');
  const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
  const current = carousel.querySelector('[data-carousel-current]');
  if (!viewport || slides.length < 2) return;

  const activeIndex = () => {
    const slideWidth = slides[0].getBoundingClientRect().width + 12;
    return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / slideWidth)));
  };
  const goTo = (index) => {
    slides[(index + slides.length) % slides.length].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  };

  carousel.querySelector('[data-carousel-previous]')?.addEventListener('click', () => goTo(activeIndex() - 1));
  carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => goTo(activeIndex() + 1));
  viewport.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => { if (current) current.textContent = String(activeIndex() + 1); });
  }, { passive: true });
  viewport.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') goTo(activeIndex() - 1);
    if (event.key === 'ArrowRight') goTo(activeIndex() + 1);
  });
});
